// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"249":"41d21556","2413":"2c90259a","2920":"c24a4db4","5682":"c24a4db4","9577":"999f4f50"}[chunkId] + ".css";
};